import InterfaceConstructor from '../InterfaceConstructor';

interface TableColumnState {
    columnProp: string;
    filterVisible: boolean | undefined;
    searchText: string | null;
    filtered: boolean | undefined;
}

const TableColumnState: InterfaceConstructor<TableColumnState> = {
    create: (initValues?: {} | null | undefined) => {
        return Object.assign(
        {
            columnProp: '',
            filterVisible: false,
            searchText: null,
            filtered: false
        },
        initValues);
    }
};

export default TableColumnState;



// WEBPACK FOOTER //
// ./src/models/datatable/TableColumnState.ts